import React from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'components/core/Page';
import { H1, Text } from 'components/core/Typography';
import { Image } from 'components/core/Image';
import { Picture } from 'components/core/Picture';
import { breakpointsByName } from 'config/breakpoints';
import BestPrice from 'assets/images/icons/best-price.svg';
import HomeHero from 'assets/images/icons/home-hero.webp';
// Relative path, not the assets/ alias - babel-plugin-module-resolver
// resolves that alias by checking the path on disk, and the literal
// `?url`-suffixed path doesn't exist as a file, so it goes unrewritten and
// webpack can't resolve it. See UnitIconV2.js for the same gotcha.
import HomeHeroMobile from '../../../assets/images/icons/home-hero-mobile.webp?url';
import { SearchSection } from 'components/landing';
import { withExperiment } from '@sparefoot/react-core/decorators';

import './HomeHeroBanner.scss';

export const enhance = withExperiment('sf_15934_ssdc_aa_test');

export function HomeHeroBanner() {
	// breakpointsByName.large must stay pinned to $breakpoints.large in
	// app/styles/_variables.scss - that's the width .home-hero-illustration
	// switches size at, so the media query and the CSS breakpoint can't drift.
	const heroBreakpoint = breakpointsByName.large;
	// Legacy min/max-width syntax, not the (width < Npx) range syntax -
	// these strings render into <link media>/<source media> attributes,
	// which postcss-preset-env's media-query-ranges downlevel never sees
	// (it only processes stylesheets), and .browserslistrc still targets
	// and_qq/and_uc/kaios, which lack native range-syntax support.
	const mobileMedia = `(max-width: ${heroBreakpoint - 0.01}px)`;
	const desktopMedia = `(min-width: ${heroBreakpoint}px)`;

	return (
		<section className="hero-section">
			<Helmet>
				<link
					rel="preload"
					as="image"
					href={HomeHeroMobile}
					media={mobileMedia}
					fetchPriority="high"
				/>
				<link
					rel="preload"
					as="image"
					href={HomeHero}
					media={desktopMedia}
					fetchPriority="high"
				/>
			</Helmet>
			<Container className="top-row">
				<div className="text-column">
					<H1
						color="black"
						weight="extraBold"
						size="mega"
						className="hero-heading-top"
					>
						Find the Perfect Storage Unit <br />
						<Text
							size="mega"
							className="best-price"
						>
							at the Best Price{' '}
						</Text>
						<Image
							alt="best price icon"
							src={BestPrice}
							className="best-price-image"
						/>
					</H1>
				</div>
				<div>
					<Picture
						alt="home furnishing icon"
						src={HomeHero}
						className="home-hero-illustration"
						loading="eager"
						fetchPriority="high"
						sources={[
							{
								media: mobileMedia,
								srcSet: HomeHeroMobile,
								type: 'image/webp',
							},
							{
								media: desktopMedia,
								srcSet: HomeHero,
								type: 'image/webp',
							},
						]}
					/>
				</div>
			</Container>
			<SearchSection />
		</section>
	);
}

export default enhance(HomeHeroBanner);
